import Navbar from "../components/NavBar";
import Footer from "../components/Footer";
import HeroLicenciatura from "../components/TopPage";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";

export default function Personal() {
  const navigate = useNavigate();

  return (
    <div className="app-root" style={{ position: "relative" }}>
      <Navbar />
      <main style={{ position: "relative", zIndex: 1 }}>
        <HeroLicenciatura
          title="NUESTRO PERSONAL"
          highlight="DOCENTE."
          subtitle=""
          cct=""
        />
      </main>

      <section
        style={{
          width: "100%",
          background: "#fff",
          padding: "clamp(28px, 4vw, 56px) 0",
        }}
      >
        <div
          style={{
            maxWidth: 1200,
            margin: "0 auto",
            padding: "0 clamp(14px, 3vw, 24px)",
            textAlign: "center",
          }}
        >
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(280px, 320px))",
              justifyContent: "center",
              gap: "clamp(14px, 2.6vw, 26px)",
              alignItems: "stretch",
            }}
          >
            {[
              {
                name: "Dra. Elizabeth Céspedes Ochoa",
                role: "Directora Facultad de Ciencias Administrativas y Tecnologías Digitales",
                email: "fcayted@unicach.mx",
                img: "/images/docentes/Default_pfp.jpg",
              },
              {
                name: "Mtro. Christian Cruz Hernández",
                role: "Coordinador de la Lic. en Marketing Digital",
                email: "christian.cruz@unicach.mx",
                img: "/images/docentes/DSc00479.jpg",
              },
            ].map((p, idx) => (
              <div
                key={idx}
                style={{
                  border: "2px solid rgba(244,166,64,0.65)",
                  borderRadius: 10,
                  padding: "clamp(16px, 2vw, 22px)",
                  background: "#fff",
                  boxShadow: "0 12px 30px rgba(0,0,0,0.06)",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  width: "100%",
                  maxWidth: 320,
                }}
              >
                <div
                  style={{
                    width: "clamp(140px, 18vw, 180px)",
                    height: "clamp(140px, 18vw, 180px)",
                    borderRadius: "50%",
                    border: "3px solid rgba(244,166,64,0.8)",
                    overflow: "hidden",
                    marginBottom: 14,
                    background: "#f7f7f7",
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}${p.img}`}
                    alt={p.name}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      display: "block",
                    }}
                  />
                </div>

                <div
                  style={{
                    color: "#0f3b63",
                    fontWeight: 900,
                    fontSize: "1.05rem",
                    lineHeight: 1.25,
                    marginBottom: 8,
                    textAlign: "center",
                    padding: "0 6px",
                    minHeight: 44,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {p.name}
                </div>

                <div
                  style={{
                    color: "#8a8f99",
                    fontSize: "0.92rem",
                    lineHeight: 1.35,
                    marginBottom: 10,
                    textAlign: "center",
                    minHeight: 42,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "0 8px",
                  }}
                >
                  {p.role}
                </div>

                <div
                  style={{
                    color: "#0f3b63",
                    fontWeight: 800,
                    fontSize: "0.95rem",
                    marginBottom: 14,
                    textAlign: "center",
                  }}
                >
                  {p.email}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section
        style={{
          width: "100%",
          background: "#fff",
          padding: "clamp(26px, 4vw, 56px) 0",
        }}
      >
        <div
          style={{
            maxWidth: 1200,
            margin: "0 auto",
            padding: "0 clamp(14px, 3vw, 24px)",
            textAlign: "center",
          }}
        >
          <h2
            style={{
              margin: "0 0 clamp(18px, 2.6vw, 28px) 0",
              fontSize: "clamp(1.9rem, 3.6vw, 2.6rem)",
              color: "#0f3b63",
              fontWeight: 900,
              letterSpacing: "0.02em",
              textTransform: "uppercase",
            }}
          >
            PERSONAL ACADÉMICO
          </h2>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
              gap: "clamp(14px, 2.6vw, 26px)",
              alignItems: "stretch",
              justifyItems: "center",
            }}
          >
            {[
              {
                name: "Mtro. Billerman Culebro Camacho",
                role: "Docente / Tutor académico",
                email: "billerman.culebro@unicach.mx",
                img: "/images/docentes/BILLERMAN_CULEBRO_CAMACHO.jpg",
              },
              {
                name: "Mtro. Juan Antonio Martínez Cruz",
                role: "Docente / Tutor académico",
                email: "juan.martinez@unicach.mx",
                img: "/images/docentes/Juan_Antonio_Martínez_Cruz.jpg",
              },
              {
                name: "Dra. Dolores Guadalupe Sosa Zúñiga",
                role: "Docente / Tutor académico",
                email: "dolores.sosa@unicach.mx",
                img: "/images/docentes/Dolores_Guadalupe_Sosa_Zuniga.jpg",
              },
              {
                name: "Mtra. Ana Sofía Ramírez Cruz",
                role: "Docente / Tutor académico",
                email: "ana.ramirezc@unicach.mx",
                img: "/images/docentes/Default_pfp.jpg",
              },
              {
                name: "Mtra. Paola Shazel Arce Marín",
                role: "Docente / Tutor académico",
                email: "paola.arce@unicach.mx",
                img: "/images/docentes/Paola_Shazel_Arce_Marin.jpg",
              },
              {
                name: "Dr. Daniel Roque Figueroa",
                role: "Docente / Tutor académico",
                email: "daniel.roque@unicach.mx",
                img: "/images/docentes/Daniel_Roque_Figueroa.jpeg",
              },
              {
                name: "Mtra. Bertha Karina Bravo Ocaña",
                role: "Docente / Tutor académico",
                email: "bertha.bravo@unicach.mx",
                img: "/images/docentes/Bertha_Karina_Bravo_Ocana.png",
              },
              {
                name: "Mtro. Mario Alberto Carrillo Ancheyta",
                role: "Docente / Tutor académico",
                email: "mario.carrillo@unicach.mx",
                img: "/images/docentes/DSC00655.jpg",
              },
              {
                name: "Mtra. Alma Chávez Toledo",
                role: "Docente / Tutor académico",
                email: "alma.chavez@unicach.mx",
                img: "/images/docentes/Alma_Chavez_Toledo.png",
              },
              {
                name: "Mtra. Gloriana Coutiño López",
                role: "Docente / Tutor académico",
                email: "gloriana.coutino@unicach.mx",
                img: "/images/docentes/Gloriana_Coutino_Lopez.jpg",
              },
              {
                name: "Dr. Jesús Manuel Grajales Romero",
                role: "Docente / Tutor académico",
                email: "jesus.grajales@unicach.mx",
                img: "/images/docentes/Jesus_Manuel_Grajales_Romero.png",
              },
              {
                name: "Mtro. Bernardo López Maldonado",
                role: "Docente / Tutor académico",
                email: "bernardo.lopez@unicach.mx",
                img: "/images/docentes/DSC00424.jpg",
              },
              {
                name: "Mtro. Roberto Maldonado Oliva",
                role: "Docente / Tutor académico",
                email: "roberto.maldonado@unicach.mx",
                img: "/images/docentes/Default_pfp.jpg",
              },
              {
                name: "Mtro. Julio Alejandro Aguilar Aguilera",
                role: "Docente",
                email: "julio.aguilar@unicach.mx",
                img: "/images/docentes/Julio_Alejandro_Aguilar_Aguilera.jpg",
              },
              {
                name: "Mtro. Alfredo Chanona Nuricumbo",
                role: "Técnico académico",
                email: "alfredo.chanona@unicach.mx",
                img: "/images/docentes/Default_pfp.jpg",
              },
            ].map((p, idx) => (
              <div
                key={idx}
                style={{
                  border: "2px solid rgba(244,166,64,0.65)",
                  borderRadius: 10,
                  padding: "clamp(16px, 2vw, 22px)",
                  background: "#fff",
                  boxShadow: "0 12px 30px rgba(0,0,0,0.06)",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  width: "100%", // ✅ NUEVO
                  maxWidth: 360, // ✅ NUEVO (ajústalo a tu gusto)
                }}
              >
                <div
                  style={{
                    width: "clamp(130px, 16vw, 170px)",
                    height: "clamp(130px, 16vw, 170px)",
                    borderRadius: "50%",
                    border: "3px solid rgba(244,166,64,0.8)",
                    overflow: "hidden",
                    marginBottom: 14,
                    background: "#f7f7f7",
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}${p.img}`}
                    alt={p.name}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      display: "block",
                    }}
                  />
                </div>

                <div
                  style={{
                    color: "#0f3b63",
                    fontWeight: 900,
                    fontSize: "1.02rem",
                    lineHeight: 1.25,
                    marginBottom: 8,
                    minHeight: 44,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    padding: "0 6px",
                  }}
                >
                  {p.name}
                </div>

                <div
                  style={{
                    color: "#8a8f99",
                    fontSize: "0.92rem",
                    lineHeight: 1.35,
                    marginBottom: 10,
                  }}
                >
                  {p.role}
                </div>

                <div
                  style={{
                    color: "#0f3b63",
                    fontWeight: 800,
                    fontSize: "0.93rem",
                    marginBottom: 14,
                  }}
                >
                  {p.email}
                </div>

                {/*<Button
                  label="Ver más"
                  style={{
                    marginTop: "auto",
                    borderRadius: 999,
                    padding: "0.7rem 1.6rem",
                    fontWeight: 800,
                    background: "#0f3b63",
                    border: "none",
                    color: "#fff",
                  }}
                  onClick={() => {}}
                />*/}
              </div>
            ))}
          </div>
        </div>
      </section>

      <section
        className="w-full"
        style={{
          padding: "2.5rem 1rem",
          background: "linear-gradient(90deg,#0f3b63 0%, #0a2e53 100%)",
        }}
      >
        <div
          className="grid align-items-center"
          style={{ maxWidth: 1200, margin: "0 auto" }}
        >
          {/* Texto + botón */}
          <div
            className="col-12 md:col-7"
            style={{ color: "#fff", paddingRight: "1rem" }}
          >
            <h2
              style={{
                margin: 0,
                marginBottom: 10,
                fontWeight: 900,
                letterSpacing: ".5px",
              }}
            >
              ¿QUIERES SABER MÁS?
            </h2>
            <p style={{ marginTop: 0, opacity: 0.95 }}>
              Da click al botón para conocer más sobre la licenciatura.
            </p>

            <Button
              label="Más información"
              onClick={() => navigate("/convocatoria")}
              style={{
                background: "#F2933F",
                borderColor: "#F2933F",
                color: "#0f3b63",
                fontWeight: 700,
                borderRadius: 999,
                padding: "0.9rem 1.4rem",
              }}
            />
          </div>

          {/* Logo a la derecha */}
          <div
            className="col-12 md:col-5 flex justify-content-end"
            style={{ paddingLeft: "1rem" }}
          >
            <img
              src={`${process.env.PUBLIC_URL}/images/Logo.png`} /* coloca tu logo en /public/images/md_logo.png */
              alt="Lic. en Marketing Digital UNICACH"
              style={{
                maxWidth: 280,
                width: "100%",
                height: "auto",
                filter: "drop-shadow(0 6px 16px rgba(0,0,0,.15))",
              }}
            />
          </div>
        </div>
      </section>

      <section
        className="w-full"
        style={{ background: "#fff", padding: "2.5rem 1rem" }}
      >
        <div style={{ maxWidth: 1200, margin: "0 auto" }}>
          <div
            style={{
              color: "#F2933F",
              fontWeight: 800,
              letterSpacing: ".5px",
              marginBottom: 6,
            }}
          >
            NUESTRAS
          </div>
          <h2
            style={{
              color: "#0f3b63",
              fontWeight: 900,
              marginTop: 0,
              marginBottom: 24,
            }}
          >
            REDES SOCIALES
          </h2>

          <div className="grid">
            {/* Facebook */}
            <div className="col-12 md:col-4 p-2">
              <a
                href="https://facebook.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex flex-column align-items-center justify-content-center w-full"
                style={{
                  textDecoration: "none",
                  border: "3px solid #F3B067",
                  borderRadius: 16,
                  padding: "2rem 1rem",
                  transition: "all .2s ease",
                  color: "#0f3b63",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.boxShadow =
                    "0 10px 22px rgba(15,59,99,.12)")
                }
                onMouseLeave={(e) => (e.currentTarget.style.boxShadow = "none")}
              >
                <i
                  className="pi pi-facebook"
                  style={{ fontSize: 64, color: "#0f3b63" }}
                />
                <div style={{ marginTop: 16, fontSize: 22, fontWeight: 700 }}>
                  Facebook
                </div>
              </a>
            </div>

            {/* Instagram */}
            <div className="col-12 md:col-4 p-2">
              <a
                href="https://instagram.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex flex-column align-items-center justify-content-center w-full"
                style={{
                  textDecoration: "none",
                  border: "3px solid #F3B067",
                  borderRadius: 16,
                  padding: "2rem 1rem",
                  transition: "all .2s ease",
                  color: "#0f3b63",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.boxShadow =
                    "0 10px 22px rgba(15,59,99,.12)")
                }
                onMouseLeave={(e) => (e.currentTarget.style.boxShadow = "none")}
              >
                <i
                  className="pi pi-instagram"
                  style={{ fontSize: 64, color: "#0f3b63" }}
                />
                <div style={{ marginTop: 16, fontSize: 22, fontWeight: 700 }}>
                  Instagram
                </div>
              </a>
            </div>

            {/* YouTube */}
            <div className="col-12 md:col-4 p-2">
              <a
                href="https://youtube.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex flex-column align-items-center justify-content-center w-full"
                style={{
                  textDecoration: "none",
                  border: "3px solid #F3B067",
                  borderRadius: 16,
                  padding: "2rem 1rem",
                  transition: "all .2s ease",
                  color: "#0f3b63",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.boxShadow =
                    "0 10px 22px rgba(15,59,99,.12)")
                }
                onMouseLeave={(e) => (e.currentTarget.style.boxShadow = "none")}
              >
                <i
                  className="pi pi-youtube"
                  style={{ fontSize: 64, color: "#0f3b63" }}
                />
                <div style={{ marginTop: 16, fontSize: 22, fontWeight: 700 }}>
                  Youtube
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
